import React from 'react';
import { Link } from 'react-router-dom';
import { FiDollarSign, FiPercent, FiClock, FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../components/SafeIcon';
import PageHeader from '../components/shared/PageHeader';

const Financing = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <PageHeader 
        title="Flexible Financing Options" 
        subtitle="Don't let budget constraints keep you from being comfortable. We offer flexible payment plans for new installations."
        image="https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&q=80&w=2000"
      />

      <section className="section-padding bg-bg">
        <div className="container-custom">
          
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl font-bold mb-6">Invest in Comfort Today, Pay Over Time</h2>
            <p className="text-lg text-muted">
              A new HVAC system is a significant investment in your home's value and your family's comfort. We've partnered with leading financial institutions to provide competitive financing rates so you can upgrade immediately without the stress of a large upfront payment.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiPercent} className="text-3xl text-primary" />
              </div>
              <h3 className="text-xl font-bold mb-3">0% Interest Plans</h3>
              <p className="text-muted">Available for 12, 24, or 36 months on qualifying high-efficiency systems (OAC).</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 text-center relative overflow-hidden">
              <div className="absolute top-0 right-0 bg-accent text-white text-xs font-bold px-3 py-1 rounded-bl-lg">POPULAR</div>
              <div className="w-16 h-16 bg-orange-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiClock} className="text-3xl text-accent" />
              </div>
              <h3 className="text-xl font-bold mb-3">Low Monthly Payments</h3>
              <p className="text-muted">Extended terms up to 120 months to keep your monthly payments as low as possible.</p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 text-center">
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiCheckCircle} className="text-3xl text-primary" />
              </div>
              <h3 className="text-xl font-bold mb-3">Fast Approvals</h3>
              <p className="text-muted">Paperless application process with decisions usually returned within minutes.</p>
            </div>
          </div>

          {/* Example Calculator Placeholder */}
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
            <div className="bg-primary text-white p-6 text-center">
              <h3 className="text-2xl font-bold">Estimate Your Payments</h3>
              <p className="text-blue-100 text-sm mt-2">See how affordable a new system can be.</p>
            </div>
            <div className="p-8 md:p-12">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                
                {/* Sliders (Visual only) */}
                <div className="space-y-8">
                  <div>
                    <div className="flex justify-between mb-2">
                      <span className="font-semibold text-gray-700">Project Cost</span>
                      <span className="font-bold text-primary">$8,500</span>
                    </div>
                    <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div className="w-1/2 h-full bg-secondary"></div>
                    </div>
                    <div className="flex justify-between mt-1 text-xs text-gray-400">
                      <span>$2,000</span>
                      <span>$15,000+</span>
                    </div>
                  </div>
                  
                  <div>
                    <div className="flex justify-between mb-2">
                      <span className="font-semibold text-gray-700">Term Length</span>
                      <span className="font-bold text-primary">60 Months</span>
                    </div>
                    <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div className="w-1/2 h-full bg-secondary"></div>
                    </div>
                    <div className="flex justify-between mt-1 text-xs text-gray-400">
                      <span>12 Mo</span>
                      <span>120 Mo</span>
                    </div>
                  </div>
                </div>

                {/* Result */}
                <div className="bg-gray-50 rounded-xl p-8 text-center border border-gray-100">
                  <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">Estimated Monthly Payment</p>
                  <div className="text-5xl font-black text-primary mb-4">
                    <span className="text-2xl align-top mr-1">$</span>165<span className="text-xl text-gray-400 font-normal">/mo</span>
                  </div>
                  <p className="text-xs text-gray-400 mb-6">*Based on 5.99% APR. Subject to credit approval.</p>
                  <Link to="/quote" className="btn-primary w-full">Apply Now</Link>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Financing;